'use client';
import { useRouter } from 'next/navigation';
import React from 'react';
import { appPublicConfig } from '@/configs/appPublicConfig';
import { BasicLayout } from '@/shared/components/layouts/BasicLayout';
import { useUserInfoAndMenus } from '@/shared/hooks/useUserInfoAndMenus';
import type { ScenarioData } from '../getScenarioData';

export const UserCreateGuestGuard: React.FC<
  React.PropsWithChildren & {
    data: ScenarioData | null;
    fallback?: React.ReactNode;
  }
> = ({
  data,
  children,
  fallback = <BasicLayout options={appPublicConfig} />,
}) => {
  const router = useRouter();
  const [isMounted, setIsMounted] = React.useState<boolean>(false);
  const { isLoadedUserInfo, userInfo } = useUserInfoAndMenus();

  const url = data?.backUrl ?? appPublicConfig.VIDEO;

  React.useEffect(() => {
    if (!isLoadedUserInfo) return;
    if (isMounted) return;

    if (userInfo.isLoggedIn) {
      router.replace(url);
      return;
    }

    setIsMounted(true);
  }, [isLoadedUserInfo, isMounted, router, url, userInfo.isLoggedIn]);

  return isMounted ? <>{children}</> : <>{fallback}</>;
};
